export default __webpack_public_path__ + "static/media/gmx-logo-glow.e17dff22.png";